import { Edit, Ellipsis, Trash, Trash2 } from 'lucide-react'

import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarShortcut,
  MenubarTrigger,
} from '@components/common/menu-bar'
import { DictType } from '@pma/types'
import { Separator } from '@components/common/separator'
import useTranslator from '@hooks/use-translator'
import { useMutation } from '@tanstack/react-query'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { parseCookies } from 'nookies'
import { ACCESS_TOKEN } from '@pma/utils/constants'
import { toast } from '@hooks/use-toast'
import axios from 'axios'
import { DELETE_NOTE_ENDPOINT, SERVER_URL } from '@pma/utils/api-routes'
import UpdateNote from './update-note'
import { useState } from 'react'
import DeleteNote from './delete-note'

interface Props {
  note: DictType;
  fromExpandCalling?:boolean
}
const NoteMenuOptions = ({ note ,fromExpandCalling=false}: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenDelete,setIsOpenDelete] = useState(false)
  const { translate } = useTranslator()
  const navigate = useNavigate()
  const accessToken = parseCookies()[ACCESS_TOKEN]
  const [searchParam] = useSearchParams();
  const newParams = new URLSearchParams(searchParam);
    

  const deleteNote = async () => {
    const response = await axios.delete(
      SERVER_URL + DELETE_NOTE_ENDPOINT + `/${note?.id}`,

      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    )

    return response.data
  }

  const deleteNoteMutation = useMutation({
    mutationFn: deleteNote,
    onSuccess: (data) => {
      newParams.set('revalidate', 'tasks');
      navigate(`?${newParams.toString()}`);

      toast({
        title: translate('Success'),
        description: translate('Note deleted successfully'),
        variant: 'success',
      })
    },
    onError: (error: DictType) => {
      const errorMessage = error?.response?.data?.message

      toast({
        title: translate('Error'),
        description: errorMessage || translate('An error occurred'),
        variant: 'error',
      })

      newParams.set('revalidate', 'tasks');
      navigate(`?${newParams.toString()}`);
    },
  })

  const setOpenModal = () => {
    setIsOpen(true)
  }

  const handleCloseDelete = ()=>{
    setIsOpenDelete(false)
  }

  return (
    <div className=''>
      {isOpen && <UpdateNote message={note} isOpen={isOpen} setIsOpen={setIsOpen} fromExpandCalling={fromExpandCalling}/>}
      {isOpenDelete && <DeleteNote triggerClass={'w-full'} note={note} defaultOpen={true} onClose={handleCloseDelete} fromExpandCalling={fromExpandCalling}/>}
      <Menubar className='border-none bg-none'>
        <MenubarMenu>
          <MenubarTrigger className='flex h-7 w-7 cursor-pointer items-center justify-center rounded-full bg-none p-0 text-black'>
            <Ellipsis size={16} className='' />
          </MenubarTrigger>
          <MenubarContent className='mx-2 gap-2 bg-background'>
            <MenubarItem
              onClick={() => setIsOpenDelete(true)}
              className='flex w-full p-1'
            >
              <Trash size={12} className='text-red-500 hover:scale-105' />
              <div className='flex-1' />
              <span className='text-red-500'>{translate('Delete')}</span>
              <MenubarShortcut></MenubarShortcut>
            </MenubarItem>
            <MenubarItem
              className='flex w-full cursor-pointer items-center justify-between p-1 text-xs'
              onClick={() => setOpenModal()}
            >
              <div className='flex w-full justify-around'>
                <Edit className='text-foreground' size={13} /> <div className='flex-1' />
                <span className='text-blue-500'>{translate('Edit')}</span>
              </div>
            </MenubarItem>
          </MenubarContent>
        </MenubarMenu>
      </Menubar>
    </div>
  )
}

export default NoteMenuOptions
